module.exports = __webpack_public_path__ + "assets/pin_offMarket.701a0705.svg";